<!-- <ul class="nav nav-tabs1 table-nav" [hidden]="getHideStatus()">
<ng-container *ngFor="let s of segment | keyvalue:returnZero">
  <li class="nav-item">
    <a class="nav-link" [class.error-segment]="segmentError[s.key] == true"
      [ngClass]="{'show active': currentSegment==s.value}" (click)="toSelectSegment(s.value)"
    href="javascript:void(0)">{{s.value | titlecase}}</a>
  </li>
</ng-container>
</ul> -->

  @if (!getHideStatus()) {
  <p-tabMenu (activeItemChange)="toSelectSegment($event)" [model]="segmentMenu" [activeItem]="currentObj">
    <ng-template pTemplate="item" let-item>
      <a class="p-menuitem-link d-flex justify-content-between align-items-center p-3">
        <div>
          <span [class]="item?.icon"></span>
          <span>{{ item.label }}</span>
        </div>
      </a>
    </ng-template>
  </p-tabMenu>
  <!-- <ul class="nav nav-tabs nav-bordered ">
    <ng-container *ngFor="let s of segment | keyvalue:returnZero">
      <li class="nav-item">
        <a class="nav-link" [class.error-segment]="segmentError[s.key] == true"
          [ngClass]="{'show active': currentSegment==s.value}" (click)="toSelectSegment(s.value)"
          href="javascript:void(0)">{{s.value | titlecase}}</a>
      </li>
    </ng-container>
  </ul> -->
  }
  @if (tabBody) {
  <div class="tab-content mt-0 tableStyle" >
    <div class="tab-pane show active">
      <div class="card">
        <div class="card-body">
          <ng-container [ngTemplateOutlet]="tabBody"
            [ngTemplateOutletContext]="{active:currentSegment,is_visited : this.segmentVisited[currentSegment] || false,visited : segmentVisited}"></ng-container>
        </div>
      </div>
    </div>
  </div>
  }
  <modify-head-info [bsModalRef]="bsModalRef" [getApiApprove]="approveRequest" #tabModify [modifyData]="modifyData"
    [data]="data" [module]="module" [type]="type"></modify-head-info>
  <ng-template pTemplate="tabFooter" #tabFooter>
    @if (type == 'MODIFICATION_APPROVE') {
    <ng-container [ngTemplateOutlet]="tabModify?.modifyFooter"></ng-container>
    } @else {
    @if (isSubmitted) {
    <div class="col-md-12 mb-2 text-center">
      @if (checkAllError()) {
      <span class="error">Few field not be valid</span>
      }
    </div>
    }
    <div class="col-md-12 text-center">
      <div class="p-buttonset p-4">
        @if ((type=='SUBMIT' || type=='MODIFICATION_SUBMIT') && !+data?.modify_request) {
        @if (!isFirstSegment()) {
        <!-- <button [disabled]="disabledBtn" (click)="prevSegment()" type="button" class="btn btn-primary mr-1">Prev</button> -->
        <p-button [disabled]="disabledBtn" icon="pi pi-arrow-left" class="me-1" (click)="prevSegment()"
          label="Prev"></p-button>
        }
        @if (showSubmit && isLastSegment()) {
        <p-button noDoubleClick [loading]="loading" [disabled]="disabledBtn || loading || checkAllError()"
          icon="pi pi-check-circle" class="me-1" (click)="onSubmit()" severity="success"
          label="{{ loading ? 'Saving...' : 'Submit'}}"></p-button>
        }
        @if (!isLastSegment()) {
        <p-button [disabled]="disabledBtn || checkSegmentStatus()" icon="pi pi-arrow-right" class="me-1"
          (click)="nextSegment()" label="Save & Next"></p-button>
        }
        }
        <p-button [disabled]="loading" icon="pi pi-times" class="me-1" severity="danger" (click)="close(false)"
          label="Cancel"></p-button>
      </div>
    </div>
    }
  </ng-template>
  
  <ng-template #modifyAlert>
    <ng-container [ngTemplateOutlet]="tabModify?.modifyAlert"></ng-container>
  </ng-template>
  
  <ng-template #modifyFooter>
    <!-- <modify-head-info #tabModify [modifyData]="modifyData" [type]="type"></modify-head-info> -->
    <ng-container [ngTemplateOutlet]="tabModify?.modifyFooter"></ng-container>
  </ng-template>
  <ng-template #modifyInfo>
    <ng-container [ngTemplateOutlet]="tabModify?.modifyInfo"></ng-container>
  </ng-template>
